import React, { Fragment, useEffect, useState } from "react";
import { Tabs, TabPanel } from "react-tabs";
import { Button, Form, FormGroup, Label } from "reactstrap";
import "../../assets/styles/admin.css";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import Loader from "../loader/loader";

const AddGiftCardForm = ({ payload, setPayload }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [initialPrice, setInitialPrice] = useState({
    price: null,
    isActive: null,
  });

  useEffect(() => {
    if (payload._id) {
      setInitialPrice({
        price: payload.amount,
        isActive: payload.isActive,
      });
    }
  }, [payload]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload({
      ...payload,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      payload._id &&
      Number(payload.price) === Number(initialPrice.price) &&
      payload.isActive === initialPrice.isActive
    ) {
      toast.error("No changes detected. Please update price or status.", {
        toastId: "noChanges",
      });
      return;
    }
    let response;
    try {
      setLoading(true);
      if (payload._id) {
        response = await adminInstance().put(
          `api/admin/updateGiftCard/${payload._id}`,
          payload,
        );
      } else {
        response = await adminInstance().post(
          `api/admin/createGiftCard`,
          payload,
        );
      }
      if (response.data.code === 200) {
        toast.success(response.data.message);
        history.push("/gift-card");
      } else {
        toast.error(response.data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      {loading && <Loader />}
      <Tabs>
        <TabPanel>
          <Form
            className="needs-validation user-add admin-type"
            onSubmit={handleSubmit}>
            <FormGroup className="row justify-content-start mx-0">
              <div className="admin-input col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">
                  <span>*</span> Price
                </Label>
                <input
                  className="form-control"
                  type="number"
                  name="price"
                  value={payload.price || ""}
                  onChange={handleChange}
                  required
                />
              </div>
            </FormGroup>

            <FormGroup>
              <div className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                <Label className="d-block col-form-label">
                  <input
                    type="radio"
                    name="isActive"
                    checked={payload.isActive === true}
                    onChange={() => setPayload({ ...payload, isActive: true })}
                  />
                  Active
                </Label>

                <Label className="d-block col-form-label">
                  <input
                    type="radio"
                    name="isActive"
                    checked={payload.isActive === false}
                    onChange={() => setPayload({ ...payload, isActive: false })}
                  />
                  Deactive
                </Label>
              </div>
            </FormGroup>

            <div className="form-button d-flex justify-content-start pt-3">
              <Button
                disabled={loading}
                color="primary"
                type="submit"
                className="main-btn">
                Submit
              </Button>
            </div>
          </Form>
        </TabPanel>
      </Tabs>
    </Fragment>
  );
};

export default AddGiftCardForm;
